import { now, setHours } from "../../../shared/utils/date";

export const isDateDisabled = (
  date: Date,
  enableFuture: boolean,
  minDate?: Date | null,
  maxDate?: Date | null,
): boolean => {
  const checkDate = new Date(date);
  setHours(checkDate, 0, 0, 0, 0);

  // Future Check
  if (!enableFuture) {
    const today = now();
    setHours(today, 0, 0, 0, 0);
    if (checkDate > today) return true;
  }

  // Min Date Check
  if (minDate) {
    const min = new Date(minDate);
    setHours(min, 0, 0, 0, 0);
    if (checkDate < min) return true;
  }

  // Max Date Check
  if (maxDate) {
    const max = new Date(maxDate);
    setHours(max, 0, 0, 0, 0);
    if (checkDate > max) return true;
  }

  return false;
};
